import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD
} from "../../../../../constants";

import updateCustomerSavedItem from "./updateCustomerSavedItem";
import updateSharedBoardItem from "./updateSharedBoardItem";

import { getItemsType } from "../../../common/selectors";

const actionMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: updateCustomerSavedItem,
  [ITEMS_TYPE_SHARED_BOARD]: updateSharedBoardItem
};

export const updateSavedItem = item => async (dispatch, getState) =>
  await actionMap[getItemsType(getState())](dispatch, item, getState);
